import * as types from './types'

const initialState = {
  index: 0,
  name: '',
  questions: [],
  gradedQuestions: [],
  submitted: false,
  countEnded: false,
  quizCount: 0,
  isQuizOverlayClosed: false,
}
const quizReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.QUIZ:
      return {
        ...state,
        ...action.data,
      }
    case types.ANSWER:
      return {
        ...state,
        questions: action.questions,
      }
    case types.ACTIVE_QUESTION:
      return {
        ...state,
        index: action.index,
      }
    case types.RESET_QUIZ:
      return initialState

    case types.SUBMIT_QUIZ:
      return {
        ...state,
        submitted: action.submitted,
      }
    case types.ON_END_COUNT:
      return {
        ...state,
        countEnded: action.countEnded,
      }
    case types.SET_QUIZ_TIMER:
      return {
        ...state,
        quizCount: action.count,
      }
    case types.SET_CLOSE_QUIZ_OVERLAY:
      return {
        ...state,
        isQuizOverlayClosed: action.isQuizOverlayClosed,
      }

    case types.SET_GRADED_QUESTIONS:
      return {
        ...state,
        gradedQuestions: action.questions,
      }
    default:
      return state
  }
}

export default quizReducer
